import React, { useState } from "react";

export const MAX_COUNTERS = 3;

// Derive negotiation state from an offer
export function getCounterState(offer) {
  const counters = offer.counterOffers || [];
  const count = counters.length;
  const last = counters[count - 1];
  const currentPrice = last ? last.price : offer.price;
  const pendingWith = count === 0 ? "buyer" : (last.by === "buyer" ? "seller" : "buyer");
  const canCounter = count < MAX_COUNTERS;
  return { currentPrice, pendingWith, canCounter, count, last };
}

export function CounterOfferModal({ offer, by, onSubmit, onClose }) {
  const { currentPrice, count } = getCounterState(offer);
  const [price, setPrice] = useState(String(currentPrice));
  const [note, setNote] = useState("");
  const roundsLeft = MAX_COUNTERS - count;

  return (
    <div className="overlay" onClick={onClose}>
      <div className="modal" style={{maxWidth:380}} onClick={e=>e.stopPropagation()}>
        <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"var(--ink3)",letterSpacing:"0.15em",marginBottom:8}}>COUNTER OFFER · ROUND {count+1} OF {MAX_COUNTERS}</div>
        <div style={{fontFamily:"'Playfair Display',serif",fontSize:22,marginBottom:4}}>Make a counter offer</div>
        {roundsLeft === 1 && <div style={{background:"rgba(217,119,6,.08)",borderRadius:8,padding:"8px 12px",fontSize:12,color:"var(--gold)",marginBottom:16}}>Last counter allowed — the other side can only accept or reject after this.</div>}
        <div style={{marginBottom:14}}>
          <label className="fl">Your Price (₹)</label>
          <input type="number" inputMode="numeric" value={price} onChange={e=>setPrice(e.target.value)} placeholder="e.g. 22000" style={{fontSize:18,fontWeight:600}}/>
        </div>
        <div style={{marginBottom:20}}>
          <label className="fl">Note <span style={{fontWeight:400,textTransform:"none",letterSpacing:0}}>(optional)</span></label>
          <textarea value={note} onChange={e=>setNote(e.target.value)} rows={2} placeholder={by==="buyer"?"Why this price? Any conditions?":"What can you offer at this price?"}/>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn-ink" style={{flex:1}} onClick={()=>{ const p=parseInt(price); if(!p||p<=0) return; onSubmit(p, note.trim()); }}>
            Submit Counter →
          </button>
          <button className="btn-ghost" onClick={onClose} style={{padding:"11px 18px"}}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// Inline counter history strip shown on offer cards
export function CounterHistory({ offer }) {
  const counters = offer.counterOffers || [];
  if (!counters.length) return null;
  return (
    <div style={{marginTop:8,borderTop:"1px solid var(--bg3)",paddingTop:8}}>
      <div style={{fontFamily:"'DM Mono',monospace",fontSize:8,color:"var(--ink3)",letterSpacing:"0.12em",marginBottom:6}}>COUNTER HISTORY</div>
      {counters.map((c,i)=>(
        <div key={i} style={{display:"flex",alignItems:"baseline",gap:8,fontSize:12,color:"var(--ink2)",marginBottom:3}}>
          <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:c.by==="buyer"?"var(--blu)":"var(--grn)",textTransform:"uppercase",flexShrink:0}}>{c.by}</span>
          <span style={{fontWeight:600,color:"var(--ink)"}}>₹{Number(c.price).toLocaleString("en-IN")}</span>
          {c.note && <span style={{color:"var(--ink3)",fontSize:11}}>· {c.note}</span>}
        </div>
      ))}
    </div>
  );
}
